<template>
    <div id="main-layout-right">
        <div id="upgrade-plan-container">
        </div>

        <RightSidebarTabs />

        <div id="lut_templates" class="invisible">
            <div id="templates_tabs"><span></span></div>
            <div id="previews-list-container" class="scrollable-con"></div>
        </div>
    </div>
</template>

<script>
import RightSidebarTabs from "@/components/app/ui/RightSidebarTabs";
import { mapGetters, mapState } from "vuex";
import { matchesStore } from "@/services/indexedDB.service";

export default {
    name: "MainLayoutRight",
    components: {
        RightSidebarTabs,
    },

    computed: {
        ...mapState("User", ["account"]),
        ...mapState("UI", ["matches"]),
        ...mapGetters('UI', ['filteredMatches']),
        ...mapGetters('User', ['isCurrentPlanFree']),
    },

    methods: {
        upgradePlan() {
            this.$router.push({ name: "account.billing.changePlan" });
        },
    }
}
</script>

<style land="scss" scoped>
#main-layout-right {
    /*grid-area: main-layout-right;*/
    display: grid;
    grid-template-rows: var(--status-container-height) auto calc(100% - var(--status-container-height) - var(--sidebar-tabs-height));
    height: 100vh;
    /*min-width: 300 px;*/
}

#upgrade-plan-container {
    display: flex;
    align-items: center;
    justify-content: stretch;
    z-index: 10;
    background-color: #121212;
}

</style>
